export const buttonBlueBg = '#2a8bda';
export const primaryBlue = '#2a8bda';
export const successGreen = '#00b2a0';
export const azulJornada = '#1371b9';
export const amareloJornada = '#ffc20d'
export const roxoJornada = '#8c4d9e';
